import { CheckedAddress } from '@sparkdotfi/common-universal'
import { useEffect, useRef } from 'react'

import { useStore } from '@/domain/state'
import { useCloseDialog } from '@/domain/state/dialogs/hooks'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'

export function DialogDispatcherContainer() {
  const openedDialog = useStore((state) => state.dialogs.openedDialog)
  const closeDialog = useCloseDialog()
  const { account } = useConnectedAddress({ throwOnNotConnected: false })
  const lastSeenAccount = useRef<CheckedAddress | undefined>(undefined)

  const closeOnAccountChange = openedDialog?.config.options.closeOnAccountChange ?? false

  useEffect(() => {
    const newAddress = account

    if (closeOnAccountChange && newAddress !== lastSeenAccount.current) {
      closeDialog()
    }

    if (newAddress !== lastSeenAccount.current) {
      lastSeenAccount.current = newAddress
    }
  }, [account, closeOnAccountChange, closeDialog])

  if (!openedDialog) {
    return null
  }

  const {
    config: { element: Dialog },
    props,
  } = openedDialog

  return <Dialog open setOpen={closeDialog} {...props} />
}
